import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { map } from 'lodash';
import { fetchCredentialsFiltersService } from '../../services';

type FilterType = {
  id: string;
  value: string;
};

export type CredentialsFiltersStateType = {
  number: string;
  plate: string;
  holderName: string;
  holderDocument: string;
  street: string;
  district: string;
  routeId: string;
  expirationDate: string;
  status: string;
  routes: {
    id: number;
    name: string;
  }[];
  filters?: {
    routes: {
      id: string;
      value: string;
    }[];
    validities: {
      id: string;
      value: string;
    }[];
    status: any;
  };
  isLoading?: boolean;
};

const initialState: CredentialsFiltersStateType = {
  number: '',
  plate: '',
  holderName: '',
  holderDocument: '',
  street: '',
  district: '',
  routeId: '',
  expirationDate: '',
  status: '',
  routes: [],
};

export const fetchCredentialsFilters = createAsyncThunk(
  'credentialsFilters',
  async () => {
    return await fetchCredentialsFiltersService();
  },
);

export const credentialsFiltersSlice = createSlice({
  name: 'credentialsFilters',
  initialState,
  reducers: {
    setIsCredentialsFiltersButtonActive: (
      state,
      action: PayloadAction<boolean>,
    ) => {
      return {
        ...state,
        isFilterButtonActive: action.payload,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchCredentialsFilters.pending, (state) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(fetchCredentialsFilters.rejected, (state) => {
      return {
        ...state,
        isLoading: false,
      };
    });
    builder.addCase(fetchCredentialsFilters.fulfilled, (state, res) => {
      const { routes, validities, status } = res.payload;

      // Map status to an array of { id, value } objects, converting id to number
      const handledStatus = map(status, (item) => ({
        id: Number(item.id),
        value: item.value,
      }));

      return {
        ...state,
        filters: {
          routes,
          validities,
          status: handledStatus,
        },
        isLoading: false,
      };
    });
  },
});

export const { setIsCredentialsFiltersButtonActive } =
  credentialsFiltersSlice.actions;
